/* tslint:disable */
/* eslint-disable */
/**
 * GateHouse AIS REST interface
 * AIS system for monitoring vessel traffic. Commercial WebService. Contact GateHouse support for more information
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: support@gatehouse.dk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  DetailedShipList,
  ErrorResponse,
  GetShiplists200Response,
} from '../models';
import {
    DetailedShipListFromJSON,
    DetailedShipListToJSON,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    GetShiplists200ResponseFromJSON,
    GetShiplists200ResponseToJSON,
} from '../models';

export interface AddShiplistRequest {
    json: DetailedShipList;
}

export interface GetShiplistRequest {
    id: string;
}

export interface ShiplistIdDeleteRequest {
    id: string;
}

export interface UpdateShiplistRequest {
    detailedShipList: DetailedShipList;
}

/**
 * 
 */
export class ShiplistApi extends runtime.BaseAPI {

    /**
     * Create a new shiplist; only \"name\" is required
     * Create a new shiplist
     */
    async addShiplistRaw(requestParameters: AddShiplistRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.json === null || requestParameters.json === undefined) {
            throw new runtime.RequiredError('json','Required parameter requestParameters.json was null or undefined when calling addShiplist.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        const response = await this.request({
            path: `/shiplist`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DetailedShipListToJSON(requestParameters.json),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Create a new shiplist; only \"name\" is required
     * Create a new shiplist
     */
    async addShiplist(requestParameters: AddShiplistRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.addShiplistRaw(requestParameters, initOverrides);
    }

    /**
     * Return the specified shiplist
     * Return a shiplist
     */
    async getShiplistRaw(requestParameters: GetShiplistRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DetailedShipList>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getShiplist.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        const response = await this.request({
            path: `/shiplist/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DetailedShipListFromJSON(jsonValue));
    }

    /**
     * Return the specified shiplist
     * Return a shiplist
     */
    async getShiplist(requestParameters: GetShiplistRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DetailedShipList> {
        const response = await this.getShiplistRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Return names and info of all shiplists available for the user. It does not return actual list of the ships in the shiplist. To get the list of ships in a shiplist call /shiplist/<id>
     * Return the names of all shiplists
     */
    async getShiplistsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetShiplists200Response>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        const response = await this.request({
            path: `/shiplist`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetShiplists200ResponseFromJSON(jsonValue));
    }

    /**
     * Return names and info of all shiplists available for the user. It does not return actual list of the ships in the shiplist. To get the list of ships in a shiplist call /shiplist/<id>
     * Return the names of all shiplists
     */
    async getShiplists(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetShiplists200Response> {
        const response = await this.getShiplistsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Delete a shiplist
     */
    async shiplistIdDeleteRaw(requestParameters: ShiplistIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling shiplistIdDelete.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        const response = await this.request({
            path: `/shiplist/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete a shiplist
     */
    async shiplistIdDelete(requestParameters: ShiplistIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.shiplistIdDeleteRaw(requestParameters, initOverrides);
    }

    /**
     * Update a shiplist; only \"name\" is required
     * Update a shiplist
     */
    async updateShiplistRaw(requestParameters: UpdateShiplistRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.detailedShipList === null || requestParameters.detailedShipList === undefined) {
            throw new runtime.RequiredError('detailedShipList','Required parameter requestParameters.detailedShipList was null or undefined when calling updateShiplist.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        const response = await this.request({
            path: `/shiplist`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: DetailedShipListToJSON(requestParameters.detailedShipList),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Update a shiplist; only \"name\" is required
     * Update a shiplist
     */
    async updateShiplist(requestParameters: UpdateShiplistRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateShiplistRaw(requestParameters, initOverrides);
    }

}
